<template>
    <v-container fluid>
        <v-row justify="center">
            <v-col cols="12">
                <responsiveButton :setText="true"
                                  setColor="orange"
                                  setDefaultIcon="mdi-refresh"
                                  setSmallIcon="mdi-refresh"
                                  :setClick="loadData"
                >
                    Refresh Data
                </responsiveButton>
                <responsiveButton :setTo="{name: 'clientDetailsEmployeesAssigment', params:{id: this.id}}"
                                  setColor="blue"
                                  setDefaultIcon="mdi-plus"
                                  setSmallIcon="mdi-plus-circle-outline"
                                  style="float: right"
                >
                    Employees
                </responsiveButton>
                <v-divider class="mx-6; mt-1"></v-divider>
                <v-data-table
                        :headers="employeesTable.headers"
                        :items="employees"
                        class="elevation-1"
                        :loading="loading"
                        loading-text="Loading... Please wait"
                >
                    <template v-slot:item.emailVerified="{item}">
                        <v-chip :color="getColorForEmail(item.emailVerified)" dark>
                            {{item.emailVerified?'': 'Not '}} Verified
                        </v-chip>
                    </template>
                    <!--actions-->
                    <template v-slot:item.view="{item}">
                        <v-icon
                                class="mr-2"
                                @click="viewEmployeeDetails(item)"
                        >
                            {{ EMPLOYEE_ACTIONS.VIEW.icon }}
                        </v-icon>
                    </template>
                    <template v-slot:item.remove="{item}">
                        <v-icon
                                class="mx-auto"
                                @click="confirmDelete(item)"
                        >
                            {{ EMPLOYEE_ACTIONS.DELETE.icon }}
                        </v-icon>
                    </template>
                </v-data-table>
            </v-col>
        </v-row>
        <dialog-alert
                :text="confirmAlertText"
                :alert-type="confirmAlertType"
                :open="openConfirmation"
                @alert-closed="dialogClosed($event)"
        ></dialog-alert>
    </v-container>
</template>

<script>
    import alertEventBus from '@/eventBus/AlertEventBus';
    const responsiveButton = ()=> import( '@/components/common/mobile/Button');
    const DialogAlert = () => import("@/components/common/DialogAlert");
    import { ALERT_TYPES, CONFIRM_UNASSIGMENT } from "@/shared/enums/AlertTexts";
    import {EMPLOYEE_ACTIONS} from "@/shared/enums/Employee";

    export default {
        name: "clientEmployeeTable",
        components: { responsiveButton, DialogAlert },
        props:["id", "type"],
        data(){
            return {
                employees: [],
                client: null,
                loading: true,
                employeesTable: {
                    headers: [
                        {
                            text: 'Name',
                            align: 'center',
                            sortable: true,
                            value: 'name',
                        },
                        {
                            text: 'Address',
                            align: 'center',
                            sortable: true,
                            value: 'address'
                        },
                        {
                            text: 'Employee Type',
                            align: 'center',
                            sortable: true,
                            divider: true,
                            value: 'typeName'
                        },
                        {
                            text: 'View',
                            align: 'center',
                            width: '2%',
                            value: 'view',
                            sortable: false
                        },
                        {
                            text: 'Remove',
                            align: 'center',
                            width: '2%',
                            value: 'remove',
                            sortable: false
                        }
                    ]
                },
                confirmAlertType: ALERT_TYPES.CONFIRM,
                confirmAlertText: CONFIRM_UNASSIGMENT,
                openConfirmation: false,
                itemtoUnAssigment: null
            };
        },
        computed:{
            EMPLOYEE_ACTIONS(){
                return EMPLOYEE_ACTIONS;
            }
        },
        methods:{
            async loadData(){
                try {
                    //call store type
                    let getForType = 'getClient';
                    await this.$store.dispatch(getForType, {id: this.id});
                    let user = this.$store.getters[getForType];

                    if(!!!user){
                        throw {message: `Not valid ${this.path_type} found for id: ${this.path_id}`};
                    }
                    this.employees = [];
                    this.client = {...user};
                    this.$log.debug(this.client)

                    if(this.client.employees)
                    {
                        Object.keys(this.client.employees).forEach(elem => {
                            let data = this.client.employees[elem];

                            this.employees.push({
                                id: elem,
                                name: data.name,
                                address: data.address,
                                typeName: data.typeName
                            });
                        })
                    }

                    this.loading = false;
                }
                catch (e) {
                    //set alert
                    alertEventBus.setAlert({type:'error', msg: e.message});
                    return;
                }
            },
            async deleteAssignment(user) {
                try {
                    //remove
                    delete this.client.employees[user.id]
                    await this.$store.dispatch('setClient', this.client);

                    await this.$store.dispatch('getEmployee', {id: user.id});
                    let employee = this.$store.getters.getEmployee;
                    //remove
                    delete employee.clients[this.client.id];
                    await this.$store.dispatch('setEmployee', employee);
                }
                catch (e) {
                    alertEventBus.setAlert({ type: "error", msg: e.message });
                    return;
                }
                this.itemtoUnAssigment = null;
                this.loadData();
            },
            viewEmployeeDetails(client){
                this.$router.push({name: EMPLOYEE_ACTIONS.VIEW.route, params:{id:client.id}});
            },
            confirmDelete(item) {
                this.openConfirmation = true;
                this.itemtoUnAssigment = item;
            },
            dialogClosed(answer) {
                this.openConfirmation = false;
                if (answer) {
                    this.deleteAssignment(this.itemtoUnAssigment);
                }
            }
        },
        async created(){
            await this.loadData();
        }
    }
</script>

<style>
    .v-chip.white-span span {
        color: white !important;
    }
</style>